module.exports = __webpack_public_path__ + "img/personal_resources_dispose.41eb4373.svg";